import Link, {LinkProps} from "next/link";
import React from "react";

type LinkOrButtonProps =
  | ({
      href?: LinkProps["href"] | null;
      shallow?: LinkProps["shallow"];
      as?: LinkProps["as"];
    } & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "shallow" | "as">)
  | ({
      href?: undefined | null;
      shallow?: undefined | null;
      as?: undefined | null;
    } & React.ButtonHTMLAttributes<HTMLButtonElement>);

const LinkOrButton = React.memo(
  ({
    href,
    shallow,
    as,
    children,
    ...props
  }: LinkOrButtonProps & React.ButtonHTMLAttributes<HTMLAnchorElement>) =>
    href ? (
      <Link href={href} shallow={shallow} as={as} {...props}>
        <>{children}</>
      </Link>
    ) : (
      // @ts-expect-error TS2322: Type '{ children: ReactI18NextChild | Iterable<ReactI18NextChild>; about?: string | undefined; download?: any; id?: string | undefined; ... 268 more ...; value?: string | ... 2 more ... | undefined; } | { ...; }' is not assignable to type 'DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>'.
      <button {...props}>{children}</button>
    ),
);

LinkOrButton.displayName = "LinkOrButton";

export default LinkOrButton;
